// do this whenever you load a page
// so also when loading a new history.js page
// often occurs in <main> or changing navigations

// imports --------------------------------------------------------------------
// import * as Cookies from './0-cookies-v3.1.js';
import * as Vars from './0-vars.js';
import * as Once from './2-once.js';
import * as Resize from './4-resize.js';
import * as MediaItems from './6-media-items-v1.6.js';
// import * as MyHistory from './history-v2.0.js';
// import * as VideoEmbed from './6-video-embed-v2.4.js';
import Masonry from 'masonry-layout';

// exported variables ---------------------------------------------------------

// local variables ------------------------------------------------------------
let msnryInterval;
const headerEl = document.querySelector('.header');
const pausedVideoEls = document.querySelectorAll('video[data-autoplay]');

// new page function ----------------------------------------------------------
export const setPage = () => {
  // sets all the pages
  // console.log('setPage');

  // fix for local testing, before history in code ------------------------
  if (window.location.hostname.indexOf('192.168') > -1) {
    // replace in links
    const anchors = document.querySelectorAll('a');
    anchors.forEach(element => {
      const href = element.getAttribute('href');
      if (href) {
        const newLink = href.replace('localhost', window.location.hostname);
        element.setAttribute('href', newLink);
      }
    });

    // replace in forms
    const forms = document.querySelectorAll('form');
    forms.forEach(element => {
      const action = element.getAttribute('action');
      if (action) {
        const newLink = action.replace('localhost', window.location.hostname);
        element.setAttribute('action', newLink);
      }
    });

    // replace in images
    const imageEls = document.querySelectorAll('img');
    imageEls.forEach(imageEl => {
      const src = imageEl.getAttribute('data-src');
      if (src) {
        const newLink = src.split('localhost').join(window.location.hostname);
        imageEl.setAttribute('data-src', newLink);
      }

      const srcset = imageEl.getAttribute('data-srcset');
      if (srcset) {
        const newLink = srcset.split('localhost').join(window.location.hostname);
        imageEl.setAttribute('data-srcset', newLink);
      }
    });

    $baseUrl = $baseUrl.replace('localhost', window.location.hostname);
    $url = $url.replace('localhost', window.location.hostname);
    $assets = $assets.replace('localhost', window.location.hostname);
  }

  // setters -----------------------------------------------
  if (typeof MyHistory !== 'undefined') MyHistory.historySetPage();

  MediaItems.setMediaItems();

  if ($pageType === 'project' && headerEl) headerEl.dataset.status = 'project';

  let msnry;
  const itemsEl = document.querySelector('.items--msnry');
  if (itemsEl) {
    msnry = new Masonry(itemsEl, {
      itemSelector: '.item',
      columnWidth: '.item--1',
      gutter: 30,
      transitionDuration: 0 // Disable animation
    });

    // before and after fader for reasons
    clearInterval(msnryInterval);

    msnryInterval = setInterval(() => {
      if (msnry) msnry.layout();
    }, 300);

    setTimeout(() => {
      clearInterval(msnryInterval);

      msnryInterval = setInterval(() => {
        if (msnry) msnry.layout();
      }, 1000);
    }, 2000);
  }

  // if (!window.blPageTransition) // didn't always fire, or fired too early
  setInterval(() => {
    // console.log('play');
    pausedVideoEls.forEach(videoEl => videoEl.play());
  }, 1200);

  // switch ($pageType) {
  // }

  if ('observerUnblocker' in Once) Once.observerUnblocker(); // calls setResize

  // Once.fader -----------------------------------------------------
  // has to be called, because there is new content
  // must be after setting slick, because new elements are created
  setTimeout(() => {
    if ('fader' in Once) Once.fader.setFaders();
  }, 0); // more than once js fader delay
};
